import { BLACK_FRIDAY_OFFER_END_EPOCH } from './constants';

export const isBlackFridayOfferEnded = () => Date.now() > BLACK_FRIDAY_OFFER_END_EPOCH;
